module.exports = __webpack_public_path__ + "img/00044.4aa3bcfa.webp";